import {DatePipe} from '@angular/common'
import {Inject, LOCALE_ID, Pipe, PipeTransform} from '@angular/core'

@Pipe({name: 'date'})
export class ExtendedDatePipe extends DatePipe implements PipeTransform {

  constructor(@Inject(LOCALE_ID) locale: string) {
    super(locale)
  }

  transform(value: null | undefined, args?: string): null;
  transform(value: any, args: string) {
    return super.transform(value, 'dd.MM.yyyy hh:mm:ss')
  }
}
